import React, { Component } from 'react'
import currency from 'currency.js'
import { RadioOption } from '@foodsby/nutrient'

class MenuRadioAnswers extends Component {
  componentDidUpdate(prevProps) {
    const {
      meta: { error },
    } = prevProps
    if (error) {
      document.getElementById('error') &&
        document
          .getElementById('error')
          .parentNode.childNodes[0].scrollIntoView({ behavior: 'smooth' })
    }
  }
  render() {
    const {
      input,
      name,
      className,
      meta: { touched, error },
      question,
      answers,
      onAnswerChange,
      questionId,
      ...other
    } = this.props
    const { onChange } = input

    const handleChange = (event, questionId, onAnswerChange) => {
      onChange(event)
      onAnswerChange({
        answerId: event.target.value,
        selected: true,
        questionId: questionId,
      })
    }
    return (
      <div id={touched && error ? 'error' : ''}>
        {touched && error && (
          <div
            className="primary error"
            name="error"
            style={{ marginTop: '16px' }}
          >
            {error}
          </div>
        )}
        <ul className="segment-items">
          {answers.map(answer => (
            <li key={answer.id}>
              <RadioOption
                id={`answer-${answer.id}`}
                label={answer.text}
                {...input}
                checked={`${answer.id}` === `${input.value}`}
                onChange={event =>
                  handleChange(event, questionId, onAnswerChange)
                }
                value={answer.id}
                {...other}
              />
              {answer.price !== 0 && (
                <small className="segment-item_addon">
                  +
                  {currency(answer.price, {
                    formatWithSymbol: true,
                  }).format()}
                </small>
              )}
            </li>
          ))}
        </ul>
      </div>
    )
  }
}

MenuRadioAnswers.defaultProps = {
  meta: {
    touched: false,
    error: false,
  },
}

export default MenuRadioAnswers
